export const getContrastColor = (backgroundColor: string) => {
  const color = backgroundColor.substring(1)
  const rgb = parseInt(color, 16)
  const r = (rgb >> 16) & 0xff
  const g = (rgb >> 8) & 0xff
  const b = (rgb >> 0) & 0xff
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b
  return luminance > 186 ? '#000000' : '#ffffff'
}
